import EDDom from "../handler/EDDom.js"

export default class EDSection extends EDDom {
    constructor(p) {
        p.tagName = "section"
        super(p)
    }
}